/**
 * Server: 其他邮箱注册
 * App: 第三方服务
 * Tourist: 游客
 */
var LoginAccountType;
(function (LoginAccountType) {
    LoginAccountType["Phone"] = "PHONE";
    LoginAccountType["Email"] = "EMAIL";
    LoginAccountType["Openid"] = "OPENID";
    LoginAccountType["Weixin"] = "WEIXIN";
    LoginAccountType["Google"] = "GOOGLE";
    LoginAccountType["Server"] = "SERVER";
    LoginAccountType["App"] = "APP";
    LoginAccountType["Tourist"] = "TOURIST";
})(LoginAccountType || (LoginAccountType = {}));
// AccountsTypeEnum
const ACCOUNTS_TYPE_MAP = {
    email: '邮箱',
    google: '谷歌',
    phone: '手机',
    wechat: '微信',
};
const ACCOUNTS_TYPE_VALUE_MAP = {
    email: 2,
    google: 5,
    phone: 1,
};
var LoginAccountsTypeNum;
(function (LoginAccountsTypeNum) {
    LoginAccountsTypeNum[LoginAccountsTypeNum["Email"] = 2] = "Email";
    LoginAccountsTypeNum[LoginAccountsTypeNum["Google"] = 5] = "Google";
    LoginAccountsTypeNum[LoginAccountsTypeNum["Phone"] = 1] = "Phone";
})(LoginAccountsTypeNum || (LoginAccountsTypeNum = {}));
var UrsPageTypeEnum;
(function (UrsPageTypeEnum) {
    UrsPageTypeEnum["Login"] = "login";
    UrsPageTypeEnum["Register"] = "register";
})(UrsPageTypeEnum || (UrsPageTypeEnum = {}));
/**
 * CommonMail: rbac 邮箱登录，支持 163+其他邮箱（与 urs 数据不互通）
 * NetEaseMail: urs 邮箱登录，支持 163+其他邮箱
 */
var LoginType;
(function (LoginType) {
    LoginType["CommonMail"] = "3";
    LoginType["NetEaseMail"] = "2";
    LoginType["Phone"] = "1";
})(LoginType || (LoginType = {}));
const URS_PAGE_TYPE_SEARCH_KEY = 'ursType';
/**
 * 登陆后需要跳转到配置页面的页面
 */
const NEED_JUMP_PATH = ['/user/change-phone'];
const DEFAULT_URS_INCLUDE_ID = 'urs-include';
const URS_LANG_CONFIG_MAP_ZH = {
    smsBtnTxt: '登 录',
    mbBtnTxt: '登 录',
    loginText: '登 录',
    gotoRegTextMb: '去注册',
    gotoRegText: '去注册',
    regMbTxt: '注 册',
    regText: '注 册',
    goEmailLoginTxt: '邮箱帐号登录',
    goMbLoginTxt: '手机帐号登录',
    goEmailRegTxt: '邮箱帐号注册',
    goMbRegTxt: '手机帐号注册',
    gotoLoginTextMb: '去登录',
    gotoLoginText: '去登录',
    placeholder: {
        account: '请输入邮箱地址',
        pwd: '请输入密码', // nosonar
    },
    enlang: 0,
    mailloginclause: {
        list: [
        // {
        //   txt: '《用户协议》',
        //   url: 'http://reg.163.com/agreement.shtml',
        // },
        ],
    },
    uniteLoginTermsList: {
        list: [
            {
                name: '《用户协议》',
                url: 'http://reg.163.com/agreement.shtml',
            },
        ],
    },
    mbloginclause: {
        list: [
            {
                txt: '《用户协议》',
                url: 'http://reg.163.com/agreement.shtml',
            },
        ],
    },
};
const URS_LANG_CONFIG_MAP_EN = {
    smsBtnTxt: 'Log in',
    mbBtnTxt: 'Log in',
    loginText: 'Log in',
    gotoRegTextMb: 'Create account',
    gotoRegText: 'Create account',
    regMbTxt: 'Sign up',
    regText: 'Sign up',
    goEmailLoginTxt: 'Use email',
    goMbLoginTxt: 'Use mobile',
    goEmailRegTxt: 'Create account',
    goMbRegTxt: 'Create account',
    gotoLoginTextMb: 'Go to log in',
    gotoLoginText: 'Go to log in',
    placeholder: {
        account: 'Enter email address',
        pwd: 'Enter password', // nosonar
    },
    enlang: 1,
    mailloginclause: {
        list: [
        // {
        //   txt: '《user agreement》',
        //   url: 'http://reg.163.com/agreement.shtml',
        // },
        ],
    },
    uniteLoginTermsList: {
        list: [
            {
                name: '《user agreement》',
                url: 'http://reg.163.com/agreement.shtml',
            },
        ],
    },
    mbloginclause: {
        list: [
            {
                txt: '《user agreement》',
                url: 'http://reg.163.com/agreement.shtml',
            },
        ],
    },
};
const USER_ACCOUNT_URL = `/users/account`;

export { ACCOUNTS_TYPE_MAP, ACCOUNTS_TYPE_VALUE_MAP, DEFAULT_URS_INCLUDE_ID, LoginAccountType, LoginAccountsTypeNum, LoginType, NEED_JUMP_PATH, URS_LANG_CONFIG_MAP_EN, URS_LANG_CONFIG_MAP_ZH, URS_PAGE_TYPE_SEARCH_KEY, USER_ACCOUNT_URL, UrsPageTypeEnum };
